import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface ReportCandidate {
  lading_uuid: string;
  alternate_reference: string;
  customer_po: string;
  consignee_name: string;
  lading_status: string;
  delivery_date: string;
  audited: boolean;
  previously_exported: boolean;
  eligible: boolean;
  exclusion_reason: string | null;
}
export interface ReportPreview {
  ok: boolean;
  shipment_count: number;
  row_count: number;
  can_generate: boolean;
  preview_hash: string;
  unaudited_count: number;
  previously_exported_count: number;
  excluded: { lading_uuid: string; alternate_reference: string | null; reason: string }[];
  data: Record<string, string | number | null>[];
}
export interface ReportResolutionItem {
  identifier: string;
  status: 'matched' | 'not_found' | 'ambiguous' | 'ineligible';
  reason: string | null;
}
export interface ReportResolution {
  ok: boolean;
  data: ReportCandidate[];
  results: ReportResolutionItem[];
}

@Injectable({ providedIn: 'root' })
export class CustomerFinancialReportService {
  billingAccount = '';
  accounts(customer: string): Observable<any> { return this.http.get('/api/work_orders/customer_billing.php', { params: { customer_contact_uuid: customer } }); }
  private readonly url = '/api/financials/customer_financial_reports.php';
  constructor(private http: HttpClient) {}

  candidates(customer: string, offset: number, search: string): Observable<{ ok: boolean; data: ReportCandidate[]; meta: { has_more: boolean } }> {
    const params = new HttpParams().set('billing_account_uuid', this.billingAccount).set('action', 'grid_data').set('customer_contact_uuid', customer)
      .set('limit', 100).set('offset', offset).set('search', search);
    return this.http.get<{ ok: boolean; data: ReportCandidate[]; meta: { has_more: boolean } }>(this.url, { params });
  }

  preview(customer: string, ids: string[]): Observable<ReportPreview> {
    const params = new HttpParams().set('billing_account_uuid', this.billingAccount).set('action', 'preview').set('customer_contact_uuid', customer)
      .set('lading_uuids', ids.join(','));
    return this.http.get<ReportPreview>(this.url, { params });
  }

  resolve(customer: string, identifiers: string[]): Observable<ReportResolution> {
    const params = new HttpParams().set('billing_account_uuid', this.billingAccount).set('action', 'resolve').set('customer_contact_uuid', customer)
      .set('identifiers', identifiers.join('\n'));
    return this.http.get<ReportResolution>(this.url, { params });
  }

  generate(customer: string, ids: string[], previewHash: string, key: string): Observable<HttpResponse<Blob>> {
    return this.http.post(this.url, { billing_account_uuid: this.billingAccount, customer_contact_uuid: customer, lading_uuids: ids, preview_hash: previewHash }, {
      headers: new HttpHeaders().set('Idempotency-Key', key), responseType: 'blob', observe: 'response'
    });
  }
}
